import React from 'react';
import { DatePicker, ConfigProvider } from 'antd';
import dayjs from 'dayjs';
import frFR from 'antd/es/locale/fr_FR';
import 'dayjs/locale/fr';

dayjs.locale('fr');



const InputDate = ({ disabled = false, value, onChange }) => {
  const dateValue = value ? dayjs(value) : null;

  return (
<ConfigProvider locale={frFR}>
      <DatePicker variant='underlined'
        disabled={disabled}
        placeholder="Jour, mois, année"
        style={{ width: '40%' }}
        value={dateValue}
        onChange={(date, dateString) => {
          onChange && onChange(dateString);
        }}
        format="YYYY-MM-DD"
       />
    </ConfigProvider>
  );
};

export default InputDate;
